site.nav = {
	// Init navigation scripts
	init: function() {

		var $html = $('<div id="mMenu" role="navigation"></div>');
		var $mMenu = $('#mainmenu').find('.mmLevel1').clone().removeAttr('id');
		$html.append($mMenu);
		$('body').append($html);

		// Add expand link to mobile menu
		$('.children', '#mMenu ').prepend('<span class="expand"><i class="fa fa-angle-down"></span>');
		$('.selectedLevel1','#mMenu').addClass('down');
		$('.selectedLevel2','#mMenu').addClass('down');
		$('.selectedLevel3','#mMenu').addClass('down');
		$('.selectedLevel4','#mMenu').addClass('down');
		site.nav.bind();
		site.nav.appendLanguage();
		//site.nav.appendQn();
		//site.nav.hideOnScroll();
		//site.nav.prependSearch();

	},
	bind: function() {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function(e) {
			e.stopPropagation();
			e.preventDefault();

			var menuOpen = $('body').hasClass('mainmenu-open');
			site.nav.mobileToggle(e, menuOpen);

			$('#mMenu').on('click', function(e) {
				e.stopPropagation();
			});

			$('body.mainmenu-open #page').on('click', function (e) {
				$('body').removeClass('mainmenu-open');
			});

		});

		// Expand in mobile menu
		$('.expand', '#mMenu').bind('click', function(e) {
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
	},
	// Toggle mobile menu
	mobileToggle: function(e, menuOpen) {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
	},
	// Append language to site
	appendLanguage: function() {
		var $divisions = $('ul', '#divisions');
		var $menu = $('ul.mmLevel1', '#mMenu');

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function() {
			if (!$(this).hasClass('selected')) {
				var $li = $(this).clone();
				$html.append($li.find('a'));
			}
		});

		$menu.append($html);
	},

	prependSearch: function() {
		var $search = $('#searchBox').clone();
		var $menu = $('ul.mmLevel1', '#mMenu');

		var $html = $('<li class="ele-searchBox si level1"></li>');
		$html.append($search);

		$menu.prepend($html);
	},

	appendQn: function() {
		var $menu = $('#mMenu'),
			$qn = $('.qn2 ul', '#qn').clone().addClass('menu');
		$('li', $qn).addClass('level1');
		$menu.append($qn);
	},
	isResponsive : function() {
		return ($(window).width() < 1200)
	},

	hideOnScroll: function() {
		site.nav.senseSpeed = 8;
		site.nav.previousScroll = 0;

		$(window).scroll(function (event) {
			if(!$('body').hasClass('mainmenu-open') && site.nav.isResponsive()) {
				site.nav.scroller = $(this).scrollTop();
				if (site.nav.scroller - site.nav.senseSpeed > site.nav.previousScroll) {
					//$("div#header").slideUp();
					$('body').addClass("slidingUp")
				} else if (site.nav.scroller + site.nav.senseSpeed < site.nav.previousScroll) {
					//$("div#header").slideDown();
					$('body').removeClass("slidingUp")
				}
				site.nav.previousScroll = site.nav.scroller;
			}
			if($('body').scrollTop() <= 30) {
				$('body').removeClass("slidingUp")
			}
		});
	}
};

site.inits.push('site.nav.init()');
